/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Week_FilterInputs */

const en_last_week_filter = /** @type {(inputs: Last_Week_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week`)
};

const nl_last_week_filter = /** @type {(inputs: Last_Week_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgelopen week`)
};

/**
* | output |
* | --- |
* | "Last week" |
*
* @param {Last_Week_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_week_filter = /** @type {((inputs?: Last_Week_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Week_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_last_week_filter(inputs)
	return en_last_week_filter(inputs)
});